import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const categorySchemaLiteral = {
  title: 'category',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    name: { type: 'string', maxLength: 100 },
    type: { type: 'string', enum: ['income', 'expense', 'both'], maxLength: 10 },
    color: { type: ['string', 'null'], maxLength: 7 },
    icon: { type: ['string', 'null'], maxLength: 50 },
    is_active: { type: 'boolean' },
    branch_id: { type: ['string', 'null'], maxLength: 100 },
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'name', 'type', 'updated_at', 'is_deleted', 'is_active'],
  indexes: ['is_deleted', 'type', 'updated_at'],
} as const;

const schemaTyped = toTypedRxJsonSchema(categorySchemaLiteral);
export type CategoryDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const categorySchema: RxJsonSchema<CategoryDocType> = categorySchemaLiteral;
